import React from 'react';
import { withAppContext } from '../../../contexts/AppContext';
import { withHelpPanelContext } from '../../../contexts/HelpPanelContext';
import ContentData from './ContentData';
import DraftReadonlyContentData from './DraftReadonlyContentData';
import DraftEditContentData from './DraftEditContentData';

/**
 * DRAFT-SPECIFIC dispatcher between readonly and edit views.
 *
 * This is the concrete subclass of ContentData used for draft content (content that hasn't
 * been published yet, or is being updated). ContentViewer.render() produces an instance of
 * this class, which inherits ContentData's Template Method render() that decides between
 * readonly and edit views based on checkEditingEnabled().
 *
 * Overrides:
 *   - checkEditingEnabled: stricter than base — requires the CURRENT USER to hold the lock.
 *     Just having editing "allowed" (e.g. being an author) isn't enough; you must also have
 *     explicitly acquired the edit lock via the LOCK workflow event. This prevents two users
 *     from accidentally editing simultaneously.
 *
 *   - renderReadonlyView: produces the draft-specific readonly view (track-changes enabled,
 *     sends LOCK on edit).
 *
 *   - renderEditView: produces the draft-specific edit view.
 *
 * Wrapped in withAppContext + withHelpPanelContext HOCs so the component tree has access to
 * authn info (userProfile) and the right-panel controller.
 */
class DraftContentData extends ContentData {
  // @ts-expect-error TS2416 - strict migration
  protected renderReadonlyView = () => {
    return <DraftReadonlyContentData {...this.props} />;
  };

  // @ts-expect-error TS2416 - strict migration
  protected renderEditView = () => {
    return <DraftEditContentData {...this.props} />;
  };

  // Override: edit mode requires (a) the parent says editing is allowed AND
  // (b) the current user holds the workflow edit lock. The lock is acquired by clicking
  // the Edit button in the readonly view, which triggers DraftReadonlyContentData.sendWorkflowLockEvent.
  protected checkEditingEnabled = async () => {
    const { isEditingAllowed, workflow } = this.props;
    // @ts-expect-error TS2339 - strict migration
    const { userProfile } = this.props.appContext.authnInfo;

    // @ts-expect-error TS18048 - strict migration
    return isEditingAllowed && !!workflow.lock && workflow.lock.acquiredBy === userProfile.userId;
  };
}

export default withAppContext(withHelpPanelContext(DraftContentData));
